/**
 * Text used in step two of schedule D.
 */
export const ScheduleDStepTwoHelperMessages = {
    correspondingFixedLocation: `If you entered Area of Operation code ‘A’ in Item 4, enter the location number of the corresponding fixed location.`,

    // TODO: remove duplicate here in future tech debt ticket
    latitudeLongitudeTooltip: `For fixed locations, if you entered ‘N/A’; in Item 6, you must enter the geographic coordinates (latitude and longitude) of the location. If you provided an FCC Antenna Structure Registration Number or an FCC 854 File Number in Item 6, then these items are optional (see Important Antenna Structure Registration Information on page 2 of these instructions). For all other locations enter the geographic coordinates as specified in the table in the instructions for Item 4:

If ‘P’ was entered in Item 4, enter the geographic coordinates of the center point;
If ‘R’ was entered in Item 4, enter the geographic coordinates of the southeast corner of the rectangular area or box. (See also Items 21 and 22 for the Northwest corner)

Enter the latitude using the format DD-MM-SS.S, where the degrees (DD) term can have a value in the range of 0 to 72, minutes (MM) can range from 0 to 59, and seconds (SS.S) can range from 0 to 59.9. If desired, seconds may be rounded to the nearest tenth of a second (in which case, use the format DD-MM-SS.S). In the right corner, specify the direction as either N for North or S for South.

Enter the longitude using the format DDD-MM-SS, where the degrees (DDD) term can have a value in the range of 64 to 180, minutes (MM) can range from 0 to 59, and seconds (SS.S) can range from 0 to 59.9. If desired, seconds may be rounded to the nearest tenth of a second (in which case, use the format DDD-MM-SS.S). In the right corner, specify the direction as either E for East or W for West.

All coordinates must be referenced to the North American Datum of 1983 (NAD83). This information can be determined in many ways, including a GPS receiver, a 7.5-minute topographical quadrangle map of the area, or you may consult the city or county/borough/parish surveyor in your area. Topographical maps may be purchased from the U.S. Geological Survey, Washington, DC 20242 or from its office in Denver, Colorado 80225.

<b>Note</b>: Location coordinates (latitude and longitude) for sites in the Continental United States, Puerto Rico, the U.S. Virgin Islands, Alaska, Hawaii, American Samoa, and Guam must be referenced to the North American Datum of 1983 (NAD83). Coordinates for sites in the Northern Mariana Islands, Wake Island, and Midway Island should be referenced to the applicable local datums. If the source from which you obtain the coordinates still utilizes an older datum (i.e., NAD27, PRD40) you must convert to NAD83. Conversion routines are available through the internet at <a class='text-primary-800' href='https://wireless.fcc.gov/uls/utilities/nadcon.html' target='_blank'>https://wireless.fcc.gov/uls/utilities/nadcon.html</a>.`,

    radiusTooltip: `For Area of Operation codes ‘A’ or ‘P’, enter the radius of the area of operation. Enter in kilometers, rounded to the nearest tenth.
Refer to CFR 47 for limitations.`,

    streetAddressTooltip: `This item must be completed for the Fixed Location. Enter a complete description of the location such as street number and address or other geographic description such as direction and distance from a town or known landmark (i.e., RT 81, 5 km South of Fairview). P. O. Box numbers or geographical coordinates are not acceptable for this item.`,

    cityTooltip: `This item must be completed with the City in which the station is located.

If ‘P’ was entered in Item 4, enter the city or town name of the location in this item. This item is required only if Item 12 is blank.`,

    stateTooltip: `This item must be completed with the State code in which the station is located. Refer to FCC 601 Main Form Instructions, Appendix II, for a list of valid state, jurisdiction and area codes.

If ‘P’, ‘C’, ‘S’, or ‘X’ was entered in Item 4, enter the State of the location in this item (if ‘X’ was entered in Item 4, enter the State of the primary control station). Refer to FCC 601 Main Form Instructions, Appendix II, for a list of valid state, jurisdiction, and area codes.`,

    countyTooltip: `This item must be completed with the County/Borough/Parish or equivalent entity in which the station is located unless any of the following pertain to the Fixed Location:
a) The City entered in Item 10 is an Independent City that is not affiliated with a County/Borough/Parish (i.e., Baltimore, MD)
b) The State code entered in Item 11 does not have Counties/Boroughs/Parishes, enter the equivalent entity (i.e., Puerto Rico, Virgin Islands)
c) The State code entered in Item 11 is GM, Gulf of Mexico

<b>NOTE</b>: If the nearest City, County/Borough/Parish or equivalent entity and State are located in a bordering County/Borough/Parish or equivalent entity and/or State, enter a complete description of the location in Item 9 as shown in the example. Complete Item 10 if a City, Town or Village within the station's County/Borough/Parish or equivalent entity is nearby, and complete Items 11 and 12 with the County/Borough/Parish or equivalent entity and State in which the coordinates are actually located.

Example: 9) (Street) Summit Mtn near Palo Verde, Imperial County, CA
10) (City) Palo Verde
11) (State) AZ
12) (County/Borough/Parish) La Paz

If ‘C’, ‘P’ or ‘X’ was entered in Item 4, enter the County/Borough/Parish or equivalent entity of the location in this item.
This item is always required for area of operation code ‘C’. This item is required for area of operation code ‘P’ except when: (a) the City entered in Item 10 is an Independent City that is not affiliated with a County/Borough/Parish (i.e., Baltimore, MD), or (b) the State entered in Item 11 is ‘GM’ (Gulf of Mexico). FCC 601 Schedule D – Instructions April 2013 – Page 5

This item is required for area of operation code ‘X’ for Radio Service Codes IK or YK utilizing frequencies below 470 MHz except when: (a) the City entered in Item 10 is an Independent City that is not affiliated with a County/Borough/Parish (i.e., Baltimore, MD), or (b) the State entered in Item 11 is ‘GM’ (Gulf of Mexico).

<b>Note</b>: Items 13-16 only apply to Fixed Locations. If you answered ‘N/A’ in Item 6 for a Fixed Location, you must complete Items 13-16. If you provided an FCC Antenna Structure Registration Number or FCC 854 File Number in Item 6 for a Fixed Location, Items 13-16 are optional. (See Important Antenna Structure Registration Information on Page 2 of Schedule D Instructions.)`,

    groundElevationTooltip: `Enter the elevation above mean sea level (AMSL) of the ground at the antenna location. Enter this item in meters, rounded to the nearest tenth. Refer to letter ‘a’ in the antenna structure figure examples on page 7 of these instructions. This information can be determined in many ways, including a GPS receiver, 7.5 minute topographical quadrangle map of the area, or you may consult the city or county/borough/parish surveyor in your area. Topographical maps may be purchased from the U.S. Geological Survey, Washington, DC 20242 or from its office in Denver, Colorado 80225.`,

    heightOfSupportStructureTooltip: `Enter the height above ground level to the highest point of the supporting structure only. Enter this item in meters, rounded to the nearest tenth. For example, if the antenna structure consists of a building/tower combination, include any elevator shaft, flag pole, or penthouse in the overall support structure height, but not the antenna, tower, pole, or mast. If the antenna structure is a tower only, include the height of the tower but not the antenna. Refer to letter ‘b’ in the antenna structure figure examples on page 7 of these Instructions.`,

    overallHeightOfStructureTooltip: `Enter the overall height above ground level of the entire antenna structure to the highest point, including any appurtenances. Enter this item in meters, rounded to the nearest tenth. You must include antennas, dishes, obstruction lighting, etc. Refer to letter ‘c’ in the antenna structure figure examples on page 7 of these instructions.`,

    structureTypeCodeTooltip: `Enter the code for the type of structure on which the antenna is or will be mounted from the following valid structure types:
      <table class="text-sm text-tertiary-700 divide-y divide-tertiary-200">
        <thead>
        <tr>
          <th scope="col" class="text-start font-normal">Code</th>
          <th scope="col" class="text-start font-normal">Definition</th>
        </tr>
        </thead>
        <tbody class="divide-y divide-tertiary-200">
        <tr>
          <td>B</td>
          <td>Building</td>
        </tr>
        <tr>
          <td>BANT</td>
          <td>Building with Antenna on Top</td>
        </tr>
        <tr>
          <td>BMAST</td>
          <td>Building with Mast</td>
        </tr>
        <tr>
          <td>BPIPE</td>
          <td>Building with Pipe</td>
        </tr>
        <tr>
          <td>BPOLE</td>
          <td>Building with Pole</td>
        </tr>
        <tr>
          <td>BRIDG</td>
          <td>Bridge</td>
        </tr>
        <tr>
          <td>BTWR</td>
          <td>Building with Tower</td>
        </tr>
        <tr>
          <td>GTOWER</td>
          <td>Guyed structure used for communication purposes</td>
        </tr>
        <tr>
          <td>LTOWER</td>
          <td>Lattice Tower</td>
        </tr>
        <tr>
          <td>MAST</td>
          <td>Mast</td>
        </tr>
        <tr>
          <td>MTOWER</td>
          <td>Monopole</td>
        </tr>
        <tr>
          <td>NNGTANN*</td>
          <td>Guyed Tower Array</td>
        </tr>
        <tr>
          <td>NNLTANN*</td>
          <td>Lattice Tower Array</td>
        </tr>
        <tr>
          <td>NNMTANN*</td>
          <td>Monopole Array</td>
        </tr>
        <tr>
          <td>PIPE</td>
          <td>Any type of Pipe</td>
        </tr>
        <tr>
          <td>POLE</td>
          <td>Any type of Pole</td>
        </tr>
        <tr>
          <td>RIG</td>
          <td>Oil or other type of Rig</td>
        </tr>
        <tr>
          <td>SIGN</td>
          <td>Any type of Sign or Billboard</td>
        </tr>
        <tr>
          <td>SILO</td>
          <td>Any type of Silo</td>
        </tr>
        <tr>
          <td>STACK</td>
          <td>Smoke Stack</td>
        </tr>
        <tr>
          <td>TANK</td>
          <td>Any type of Tank (water, gas, etc.)</td>
        </tr>
        <tr>
          <td>TREE</td>
          <td>When used as a support for an antenna</td>
        </tr>
        <tr>
          <td>UPOLE</td>
          <td>Utility Pole/Tower used to provide service (electric, telephone, etc.)</td>
        </tr>
        </tbody>
      </table>
  * Valid Tower Arrays. Code definition: The first NN indicates the number of towers in an array. The second NN is optional and indicates the position of that tower in the array (e.g., 3GTA2 would identify the second tower in a three tower array).`,
} as const;
